import { Modal } from "react-bootstrap";
import { RiCloseLargeFill } from "react-icons/ri";

const ConfirmWalletDeleteModal = ({
  show,
  onClose,
  onConfirm,
  loading = false,
  requesterName,
  amount,
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      size="sm"
    >
      <div className="wm-modal-header">
        <h5 className="modal-title">Delete Wallet Request</h5>
        <button
          type="button"
          className="wm-modal-close"
          onClick={onClose}
          disabled={loading}
        >
          <RiCloseLargeFill size={20} />
        </button>
      </div>
      <hr className="my-1" />
      <Modal.Body>
        <p className="text-center text-danger mb-1">
          Are you sure you want to delete this wallet request?
        </p>
        {amount != null && (
          <p>
            <strong>Amount:</strong> ₹{Number(amount || 0).toFixed(2)}
          </p>
        )}
        <p className="text-muted mb-0">
          This will remove the request from the list. It cannot be restored.
        </p>
      </Modal.Body>
      <div className="modal-footer border-0 justify-content-center">
        <button
          className="btn btn-light px-4"
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </button>
        <button
          className="btn btn-danger px-4"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Yes, Delete"}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmWalletDeleteModal;

